import { pxToRem } from '../utils';
import type { TypographyVariantsOptions } from '@mui/material/styles';

const body = ['var(--font-gilroy)', 'sans-serif'].join(',');

const heading = [
  'var(--font-daxPro-bold)',
  'var(--font-gilroy)',
  'sans-serif',
].join(',');

const fontSizeH1 = {
  fontSize: pxToRem(36),
  lineHeight: 42 / 36,
};

const fontSizeH2 = {
  fontSize: pxToRem(26),
  lineHeight: 32 / 26,
};

const fontSizeH3 = {
  fontSize: pxToRem(20),
  lineHeight: 1,
};

const fontSizeText = {
  fontSize: pxToRem(17),
  lineHeight: 24 / 17,
};

const fontSizeSmall = {
  fontSize: pxToRem(15),
  lineHeight: 20 / 15,
};

const fontSizeSmallest = {
  fontSize: pxToRem(13),
  lineHeight: 16 / 13,
};

const typography: TypographyVariantsOptions = {
  fontFamily: body,
  fontWeightLight: 500,
  fontWeightRegular: 500,
  fontWeightMedium: 500,
  fontWeightBold: 700,

  h1: { fontFamily: heading, fontWeight: 700, ...fontSizeH1 },
  h2: { fontFamily: heading, fontWeight: 700, ...fontSizeH2 },
  h3: { fontFamily: heading, fontWeight: 700, ...fontSizeH3 },
  h4: { fontFamily: heading, fontWeight: 700, ...fontSizeH3 },
  h5: { fontWeight: 700, ...fontSizeH3 },
  h6: { fontWeight: 700, ...fontSizeH3 },

  bigNumber: { fontWeight: 500, ...fontSizeH2 },
  bodyLarge: { fontWeight: 500, ...fontSizeText },

  body1: { fontWeight: 500, ...fontSizeText },
  body2: { fontWeight: 500, ...fontSizeSmall },

  caption: { fontWeight: 500, ...fontSizeSmallest },

  subtitle1: { fontWeight: 500, ...fontSizeSmall },
  subtitle2: { fontWeight: 500, ...fontSizeSmall },

  overline: { fontWeight: 700, ...fontSizeSmall },
  button: { fontWeight: 500, textTransform: 'none', ...fontSizeText },
};

export default typography;
